/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Input,
} from 'antd';

// eslint-disable-next-line react/prop-types
const CandidatoContacto = ({
  form,
  rules,
  isBlocked,
}) => {
  useEffect(() => {
    const fetch = async () => {
    };
    fetch();
  }, []);
  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      name="general"
      initialValues={{ estudios_concluidos: false }}
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="numero_de_telefono"
            label="Teléfono de Casa"
            rules={rules.telefono}
            hasFeedback
          >
            <Input
              allowClear
              disabled={isBlocked}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="numero_de_celular"
            label="Teléfono Móvil"
            rules={rules.telefono}
            hasFeedback
          >
            <Input
              allowClear
              disabled={isBlocked}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="contacto_de_emergencia"
            label="Contacto de Emergencia"
            rules={[
              { required: true, message: 'El teléfono es requerido' },
              { pattern: /^[0-9]{10}$/, message: 'Ingrese un número válido de 10 dígitos' },
            ]}
            required
            hasFeedback
          >
            <Input
              allowClear
              // disabled={isBlocked}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="correo_electronico"
            rules={rules.correo_electronico}
            label="Correo Electrónico"
            hasFeedback
          >
            <Input
              allowClear
              disabled={isBlocked}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CandidatoContacto;
